import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  name: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  nameDescription: {
    id: 'studio.xzWgp6',
    defaultMessage: 'The display name of the organization',
  },
  logo: {
    id: 'studio.k81S1y',
    defaultMessage: 'Logo',
  },
  logoDescription: {
    id: 'studio.QLD5P4',
    defaultMessage: 'The logo that represents this organization',
  },
  organizationIdLabel: {
    id: 'studio.GCKu2P',
    defaultMessage: 'Please enter your Organization Id <bold>{organizationId}</bold> to continue.',
  },
  selectFile: {
    id: 'studio.G5EJ8b',
    defaultMessage: 'Select logo',
  },
  title: {
    id: 'studio.V0yq88',
    defaultMessage: 'Settings {name}',
  },
  submit: {
    id: 'studio.wSZR47',
    defaultMessage: 'Submit',
  },
  settings: {
    id: 'studio.D3idYv',
    defaultMessage: 'Settings',
  },
  email: {
    id: 'studio.sy+pv5',
    defaultMessage: 'Email',
  },
  emailDescription: {
    id: 'studio.UHheiE',
    defaultMessage: 'The email address users can use to contact this organization.',
  },
  emailInvalid: {
    id: 'studio.jv0FOj',
    defaultMessage: 'This must be a valid email address',
  },
  deleteSuccess: {
    id: 'studio.LNqVbp',
    defaultMessage: 'Successfully deleted organization.',
  },
  delete: {
    id: 'studio.MMTG5C',
    defaultMessage: 'Delete organization',
  },
  deleteHelp: {
    id: 'studio.xbYTxC',
    defaultMessage:
      'Deleting an organization cannot be undone. Organizations with blocks or app collections cannot be removed.',
  },
  deleteWarningTitle: {
    id: 'studio.2T4AGb',
    defaultMessage: 'Deleting organization',
  },
  deleteWarning: {
    id: 'studio.N8eSxg',
    defaultMessage:
      'Are you sure you want to delete this organization? This action cannot be reverted.',
  },
  deleteWithAppsWarning: {
    id: 'studio.xkWE9y',
    defaultMessage:
      'This organization has {apps} published app(s). The app(s) will be deleted with the organization. Are you sure you want to delete this organization?',
  },
  errorDelete: {
    id: 'studio.MePfdF',
    defaultMessage: 'Something went wrong trying to delete this organization',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  dangerZone: {
    id: 'studio.1fFBqQ',
    defaultMessage: 'Dangerous actions',
  },
  description: {
    id: 'studio.Q8Qw5B',
    defaultMessage: 'Description',
  },
  descriptionDescription: {
    id: 'studio./9RhC2',
    defaultMessage: 'A short description about the organization',
  },
  notMatchingOrgIds: {
    id: 'studio.tPai3N',
    defaultMessage: 'Please enter the correct organization ID.',
  },
  website: {
    id: 'studio.JkLHGw',
    defaultMessage: 'Website',
  },
  websiteDescription: {
    id: 'studio.9rXRSk',
    defaultMessage: 'The website of your organization.',
  },
  descriptionVatIdNumber: {
    defaultMessage: 'Your VAT id number.',
    id: 'studio.+NUiCV',
  },
  descriptionStreetName: {
    id: 'studio.oGJyuC',
    defaultMessage: 'Street name that will be used for invoicing.',
  },
  streetName: {
    id: 'studio.WrhuAL',
    defaultMessage: 'Street name',
  },
  descriptionHouseNumber: {
    id: 'studio.dLb8Qw',
    defaultMessage: 'House number that will be used for invoicing.',
  },
  houseNumber: {
    id: 'studio.GyoFyL',
    defaultMessage: 'House number',
  },
  descriptionCity: {
    id: 'studio.+R3lK1',
    defaultMessage: 'City that will be used for invoicing.',
  },
  city: {
    id: 'studio.TE4fIS',
    defaultMessage: 'City',
  },
  descriptionZipCode: {
    id: 'studio.Vo8m5X',
    defaultMessage: 'Zip code that will be used for invoicing.',
  },
  zipCode: {
    id: 'studio.2gnKy+',
    defaultMessage: 'Zip code',
  },
  selectCountry: {
    id: 'studio.EEdOfh',
    defaultMessage: 'Select a country',
  },
  descriptionCountry: {
    id: 'studio.pOPPD9',
    defaultMessage: 'Country that will be used for invoicing.',
  },
  country: {
    id: 'studio.vONi+O',
    defaultMessage: 'Country',
  },
  descriptionCustomerName: {
    id: 'studio.vfLJpn',
    defaultMessage: 'Customer/company name that will be printed on the invoice.',
  },
  customerName: {
    id: 'studio.61Xs6O',
    defaultMessage: 'Customer name',
  },
  vatIdNumber: {
    defaultMessage: 'VAT id number',
    id: 'studio.5Y4+LR',
  },
  descriptionInvoiceReference: {
    defaultMessage: 'Reference that will be shown on invoices.',
    id: 'studio.IZqJT1',
  },
  invoiceReference: {
    defaultMessage: 'Invoice reference',
    id: 'studio.u8z2PJ',
  },
  payments: {
    defaultMessage: 'Payments',
    id: 'studio.iYc3Ld',
  },
  paymentsHelp: {
    defaultMessage:
      'Settings in this section are related to payments concerning Appsemble subscriptions. Configuring in-app payments for your apps is done on App level, in app settings.',
    id: 'studio.hFIbId',
  },
  preferredLanguage: {
    id: 'studio.R/13HH',
    defaultMessage: 'Preferred language',
  },
  preferredLanguageHelp: {
    id: 'studio.RHDyf2',
    defaultMessage: 'The preferred language to use for organization related emails.',
  },
});
